import Vue from 'vue'
import VueRouter from 'vue-router'
import SecurityRoutes from '../modules/Security/Routes'
import WelcomeRoutes from '../modules/Home/Routes'
import FinFitRoutes from '../modules/FinFit/Routes'
import {Storage} from '../core/Utils'
import NotFound from '../core/Pages/404.vue'

Vue.use(VueRouter)

let routes = [];

let routes404 = [
  {
    // catch all 404 - define at the very end
    path: "*",
    name: '404NotFound',
    component: NotFound,
    meta: { authRequired: false, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true }
  }
];

routes = routes.concat(SecurityRoutes, WelcomeRoutes, FinFitRoutes, routes404);

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const loggedIn = !!Storage.getUser().id
  const isGuest = !!Storage.getGuest().isGuest
  if (to.meta.authRequired && (!loggedIn && !isGuest)) {
    return next({name: 'Login'})
  } else if (to.meta.quizRequired) {
    // redirect to login page if the page requires a quiz and there is not data available
    const questions = Storage.getQuestions()
    const initialTimestamp = Storage.getInitialTimestamp()
    if (!questions && !initialTimestamp) {
      return next({name: 'Login'})
    } else {
      next()
    }
  } else if (to.name === 'Login' && (loggedIn)) {
    return next({name: 'Welcome'})
  } else {
    next()
  }
})

export default router
